document.addEventListener('removeFromCart', async (event) => {
  const { productHandle, variantId, quantity, scent, skin_type, hair_type, key_ingredient } = event.detail;
  if (!productHandle || !variantId) return;

  const productData = await fetch(`${Shopify.routes.root}products/${productHandle}.js`).then((res) => res.json());
  const currVariant = productData.variants.find((variant) => variant.id === parseInt(variantId, 10));
  if (!currVariant) return;
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: 'ProductRemove',
    ecommerce: {
      currencyCode: Shopify.currency.active,
      remove: {
        products: [{
          name: productData.title,
          id: currVariant.sku,
          price: currVariant.price / 100,
          brand: productData.vendor,
          category: productData.type,
          quantity: parseInt(quantity, 10),
          dimension1: currVariant.title,
          dimension2: currVariant.id,
          dimension3: scent,
          dimension4: key_ingredient,
          dimension5: skin_type,
          dimension6: hair_type
        }],
      },
    },
  });

  console.log('%cEvent: ProductRemove', 'color: #FF9100');
  console.log(window.dataLayer);
});
